import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-actions }}\n{{outlet}}",{ moduleName: "embercom/templates/apps/app/automation/fin-ai-agent/procedures.hbs" })